<template>
  <div>
    <HorizontalMenu :items="finalItems" size="large" :bottomLine="true" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import HorizontalMenu from "@components/HorizontalMenu/HorizontalMenu.vue";

const props = defineProps({
  yourEmployeesToCoachAndInspectCount: {
    type: Number,
    default: 0,
  },
  items: {
    type: Array,
    default: null,
  },
});

const defaultItems = computed(() => [
  {
    title: "Your Employees to Inspect",
    count: props.yourEmployeesToCoachAndInspectCount,
  },
]);

const finalItems = computed(() => props.items ?? defaultItems.value);
</script>

<style scoped>
:deep(.v-tab) {
  max-width: 400px !important;
  color: #475467 !important;
}

:deep(.horizontal-tab .menu-tabs.v-tab.v-tab--active) {
  color: #7f56d9 !important;
}

:deep(
    .horizontal-large-tab
      .menu-tabs.v-tab.v-tab--active
      .count-badge
      .v-badge__badge
  ) {
  border-radius: 150px !important;
  border-color: #f2edff !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #7f56d9;
  height: 25px;
  min-width: 25px;
  display: flex;
  justify-content: center;
  align-items: center;

}

:deep(.horizontal-tab .v-tabs-slider-wrapper) {
  color: #d6bbfb !important;
}

:deep(.v-divider) {
  margin: 12px 0px !important;
}
</style>
